import { Link } from "react-router-dom";
import { Reveal, Eyebrow } from "./motion";
import { IMAGES } from "../config/site";

export default function BookingCta() {
  return (
    <section className="relative py-28 md:py-40 px-6 md:px-16 overflow-hidden" data-testid="booking-cta-section">
      <div className="absolute inset-0">
        <img src={IMAGES.nightSky} alt="" className="h-full w-full object-cover" />
        <div className="absolute inset-0 bg-ink/60" />
      </div>
      <div className="relative max-w-4xl mx-auto text-center">
        <Reveal>
          <Eyebrow className="mb-6">Ready when you are</Eyebrow>
        </Reveal>
        <Reveal delay={0.08}>
          <h2 className="display-2 text-cream">
            The valley is <span className="serif-italic text-lavglow">waiting.</span>
          </h2>
        </Reveal>
        <Reveal delay={0.16}>
          <p className="text-sage mt-6 max-w-xl mx-auto leading-relaxed">
            Two luxury domes on a working lavender farm. Book your stay here — pick your
            dates, see your total price instantly, and lock it in through our secure checkout.
          </p>
        </Reveal>
        <Reveal delay={0.24} className="mt-10 flex flex-wrap justify-center gap-4">
          <Link to="/book" className="btn-primary" data-testid="cta-book-page-button">
            Book your stay
          </Link>
          <Link to="/contact" className="btn-ghost" data-testid="cta-contact-button">
            Send an inquiry
          </Link>
        </Reveal>
      </div>
    </section>
  );
}
